// extracted by mini-css-extract-plugin
export default {"picker":"styles_picker__rMFX4"};